import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { appConfig } from 'shared/appConfig';

export const initRum = () => {
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      endpoint: 'https://dataplane.rum.eu-central-1.amazonaws.com',
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: true,
      signing: false, // If you have a public resource policy and wish to send unsigned requests please set this to false
    };

    const APPLICATION_ID = appConfig.RUMApplicationId;
    const APPLICATION_VERSION = '1.0.0';
    const APPLICATION_REGION = 'eu-central-1';

    if (APPLICATION_ID) {
      return new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
    }
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
  return undefined;
};
